<template>
        <v-card class="mx-auto d-flex flex-column flex-grow-1" max-width="374">
          <template slot="progress">
            <v-progress-linear color="deep-purple" height="10" indeterminate>
            </v-progress-linear>
          </template>
          <v-card-title>
            <v-row>
              <v-avatar color="blue-grey">
                <v-icon dark>
                  mdi-account-circle
                </v-icon>
              </v-avatar>
              <p class="ml-3">{{ person.name }} {{ person.surname }}</p>
            </v-row>
          </v-card-title>
          <v-card-text class="flex-grow-1">
            <v-row align="center" class="mx-0">
              <v-rating
                :value="parseInt(person.rating)"
                color="amber"
                dense
                half-increments
                readonly
                size="14"
              />
              <div class="grey--text ml-4">
                {{ person.rating }}
              </div>
            </v-row>
            <div class="my-4 subtitle-1 success--text">
              Cena:
              <strong>{{ person.price }} &euro;</strong>/hod
            </div>
            <div>{{ person.info }}</div>
          </v-card-text>
    <v-divider class="mx-4" />
    <v-card-actions>
      <v-row align="stretch">
        <v-col cols="7" class="mx-1">
          <v-select
            @change="error = false"
            :error="error"
            v-model="term"
            :items="terms"
            label="Vyber termín"
            dense
          />
        </v-col>
        <v-col cols="3">
          <v-btn
            color="accent darken-1"
            class="white--text mx-1"
            @click="selected"
          >
            Objednaj
          </v-btn>
        </v-col>
      </v-row>
      <!-- <v-btn color="accent darken-1" class="white--text">
              Profil upratovača
            </v-btn> -->
          </v-card-actions>
        </v-card>
</template>

<script>

export default {
  name: "PersonProfile",
  data: () => ({
      personId: null,
      term: null,
      error: false,
      
  }),
  props: ['time', 'person'],
  order(id) {
    this.personId = id;
    document.getElementById("personId").value = id;
  },
  computed: {
    terms(){
    let terms = [];
    let from = this.time.from.split(':')[0];
    let to = this.time.to.split(':')[0];
    for(let i = from; i <= to; i++){
      terms.push(`${i}:00`)
    }
    return terms
    }
  },
  methods: {
    selected(){
      let term = this.term;
      if(this.term) this.$emit('order', {...this.person, term});
      else{
        if(!this.error){
          setTimeout(()=>{
          this.error=false;
          },3000)
        }
        this.error = true;
      } 
    }
  }
}
</script>
